module.exports = require("core-js-pure/stable/instance/slice");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/slice.js
// module id = 597
// module chunks = 0